import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=56a29fdc&scoped=true&"
import script from "./Network.vue?vue&type=script&lang=js&"
export * from "./Network.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a29fdc",
  null
  
)

export default component.exports